const { post } = require("./_utils");

module.exports = async (data) => post("/install", {data});
